document.addEventListener('DOMContentLoaded', function() {
    const button = document.getElementById('fixedMobileButton');
    if (!button) return;

    // ========== CONSTANTES ==========
    const HIDE_DISTANCE = 150; // Ocultar botón a 150px del final
    const SCROLL_THROTTLE = 16; // ~60fps
    const MUTATION_DEBOUNCE = 250; // Reducido: solo hijos directos
    const RESIZE_DEBOUNCE = 100;

    // ========== ESTADO ==========
    let ticking = false;
    let scrollTop = 0;
    let isHidden = false;
    let resizeTimeout = null;
    let mutationTimeout = null;
    let contentObserver = null;
    let lastScrollTime = 0;

    // ========== FUNCIONES ==========
    function updateButtonVisibility() {
        // Usar visualViewport si está disponible (mejor con teclado virtual)
        const windowHeight = window.visualViewport
            ? window.visualViewport.height
            : window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;

        const distanceFromBottom = documentHeight - (scrollTop + windowHeight);
        const shouldHide = distanceFromBottom < HIDE_DISTANCE;

        // Actualizar estado del botón
        if (shouldHide && !isHidden) {
            button.classList.add('hidden-button');
            isHidden = true;
        } else if (!shouldHide && isHidden) {
            button.classList.remove('hidden-button');
            isHidden = false;
        }

        ticking = false;
    }

    function onScroll() {
        // ✅ THROTTLING: Evitar ejecuciones excesivas
        const now = Date.now();
        if (now - lastScrollTime < SCROLL_THROTTLE) return;
        lastScrollTime = now;

        scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (!ticking) {
            window.requestAnimationFrame(updateButtonVisibility);
            ticking = true;
        }
    }

    function onViewportChange() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            if (!ticking) {
                window.requestAnimationFrame(updateButtonVisibility);
                ticking = true;
            }
        }, RESIZE_DEBOUNCE);
    }

    // ========== CLEANUP FUNCTION - CRÍTICO ✅ ==========
    function cleanup() {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onViewportChange);
        window.removeEventListener('orientationchange', onViewportChange);

        if (window.visualViewport) {
            window.visualViewport.removeEventListener('resize', onViewportChange);
        }

        if (contentObserver) {
            contentObserver.disconnect();
        }

        if (resizeTimeout) {
            clearTimeout(resizeTimeout);
        }

        if (mutationTimeout) {
            clearTimeout(mutationTimeout);
        }
    }

    // ========== EVENT LISTENERS ==========
    window.addEventListener('load', function() {
        updateButtonVisibility();
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onViewportChange, { passive: true });
    window.addEventListener('orientationchange', onViewportChange, { passive: true });

    // Monitor visualViewport para iOS Chrome
    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', onViewportChange, { passive: true });
    }

    // ✅ MutationObserver MEJORADO: subtree: false = menos agresivo
    try {
        contentObserver = new MutationObserver(function() {
            clearTimeout(mutationTimeout);
            mutationTimeout = setTimeout(updateButtonVisibility, MUTATION_DEBOUNCE);
        });

        contentObserver.observe(document.body, {
            childList: true,
            subtree: false, // ✅ CRÍTICO: Solo monitorea hijos directos
            attributes: false,
            characterData: false
        });
    } catch (e) {
        console.warn('MutationObserver not supported');
    }

    // ✅ CLEANUP: Evitar memory leaks
    window.addEventListener('beforeunload', cleanup);
    if (window.addEventListener) {
        window.addEventListener('pagehide', cleanup); // Para SPAs
    }

    // Inicializar
    updateButtonVisibility();
});
